import React from "react";
import GetDataAscendingOrder from "../../../../service/sortService";


const tableData = require("../../../../constants/dataset/downloadData/table2.json");
const sorteddata = GetDataAscendingOrder(tableData, "language");
const SecondTable = () => {
  return (
    <div className="w-full  rounded-2xl bg-[#FFF] tableAlignment dwldDataSndTable">
      <table className="w-full ">
        <thead className="w-full text-[#363636] text-[13px] font-normal not-italic bg-gray-100 tableAlignment ">
          <tr>
            <th> Languages</th>
            <th> train(hrs)</th>
            <th> dev(hrs)</th>
            <th> eval(hrs)</th>
            <th> Total</th>
          </tr>
        </thead>
        <tbody className="text-[#363636] font-normal text-[13px] not-italic text-center ">
          {sorteddata.map((item) => {
            return (
              <tr key={item.language} className="text-[#2C2C2C] ">
                <td>{item.language}</td>
                <td>{item.train}</td>
                <td>{item.dev}</td>
                <td>{item.eval}</td>
                <td>{item.total}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SecondTable;
